<template>
  <!-- 审批节点 -->
  <div class="node-wrap">
    <!-- 发起人 child-node发起人不需要箭头 -->
    <div
      class="node-wrap-box"
      :class="{
        'child-node': isShow,
        'flow-end-node': sourceData.type === 9,
        'flow-node-selected': sourceData.id === selectedId
      }"
      @click="handlerSelected(sourceData)"
    >
      <!-- 校验提醒 -->
      <el-tooltip v-if="warnStatus" effect="light" :content="$t(warnMsg)" placement="bottom">
        <label class="warn-box">
          <i class="el-icon-warning" />
        </label>
      </el-tooltip>
      <!-- Title -->
      <div class="title" :style="{ background: colorMap.get(sourceData.type) }" @click.stop="handlerEdit">
        <div>
          <svg-icon icon-class="approval" />
          <!-- 编辑name -->
          <input
            v-show="isEdit"
            ref="inputs"
            v-model="name"
            type="text"
            class="title-input"
            :placeholder="$t('850')"
            @blur="handlerSave"
          />
          <!-- node name -->
          <span v-show="!isEdit" class="flow-title-text">{{ sourceData.nodeName }}</span>
        </div>
        <!-- 删除node -->
        <button v-if="isShow" class="close-button" @click.stop="del(sourceData)">
          <i class="el-icon-close" />
        </button>
      </div>
      <!-- selected -->
      <div class="node-wrap-content">
        <div class="textarea-style" :placeholder="placeholder">
          <p v-if="label" :title="label">{{ label }}</p>
        </div>
        <i class="el-icon-arrow-right" v-if="isShow" />
      </div>
    </div>
    <!-- add node 添加节点 -->
    <add-action v-if="sourceData.type !== 9" :source-data="sourceData" />
  </div>
</template>

<script>
import addAction from './add-action.vue'
import variable from './variable.scss'
import { showData } from '../util'
/**
 *  @override 根据节点类型获取title对应的颜色
 *  sourceData.type 0发起人 1审批人 2抄送节点 3条件分支   9结束
 *  @example colorMap.get(4) // variable color #112233
 */
const { launch, Approval, CC } = variable
const colorMap = new Map([
  [0, launch],
  [1, Approval],
  [2, CC],
  [9, launch]
])
export default {
  name: 'Approval',
  components: {
    addAction
  },
  props: {
    // 当前节点数据源
    sourceData: {
      type: Object,
      default: () => {}
    },
    // 删除当前节点
    del: {
      type: Function,
      default: () => () => {}
    },
    // 选中节点UID
    selectedId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      name: '', // 节点名称
      isEdit: false,
      colorMap // 色值映射
    }
  },
  computed: {
    warnStatus() {
      return this.sourceData.warning && this.sourceData.warning.status && this.sourceData.warning.msg
    },
    warnMsg() {
      return (this.sourceData.warning && this.sourceData.warning.msg) || ''
    },
    isShow() {
      return ![0, 9].includes(this.sourceData.type)
    },
    label: vm => showData(vm.sourceData),
    placeholder: vm => {
      const { type } = vm.sourceData
      if (type === 0) return vm.$t('162')
      if (type === 9) return vm.$t('165')
      return vm.$t('164')
    }
  },
  // 点击选中 节点添加
  inject: ['handlerSelected', 'handlerAddNode'],
  methods: {
    /**
     *  @description 节点内容展示
     *  @returns { String }
     */
    handlerNodeContent() {
      return showData(this.sourceData)
    },
    // 修改名称input展示
    handlerEdit() {
      if (!this.isShow) return false
      this.isEdit = true
      this.name = this.sourceData.nodeName
      this.$refs.inputs.focus()
      this.$nextTick(() => {
        this.$refs.inputs.select()
        this.$refs.inputs.focus()
      })
    },
    // 存储名称
    handlerSave() {
      this.isEdit = false
      this.sourceData.nodeName = this.name
    }
  }
}
</script>

<style lang="scss" scoped>
@import './node.scss';
</style>
